import { loadGSAP } from '../../externals/gsap.js';

export const defaults = {
  range: 150,     // px — distance from element center where effect activates
  strength: 0.4,  // 0–1 — how far the element moves toward the cursor
  speed: 0.3,     // seconds — follow animation duration
};

export default async function magnetic(el, options) {
  await loadGSAP();
  const { gsap } = window;

  const range    = parseFloat(options.range);
  const strength = parseFloat(options.strength);
  const speed    = parseFloat(options.speed);

  el.style.display = 'inline-block';

  const onMove = (e) => {
    const rect = el.getBoundingClientRect();
    const cx   = rect.left + rect.width  / 2;
    const cy   = rect.top  + rect.height / 2;
    const dx   = e.clientX - cx;
    const dy   = e.clientY - cy;
    const dist = Math.sqrt(dx * dx + dy * dy);

    if (dist < range) {
      gsap.to(el, {
        x: dx * strength,
        y: dy * strength,
        duration: speed,
        ease: 'power2.out',
      });
    } else {
      gsap.to(el, {
        x: 0,
        y: 0,
        duration: 0.8,
        ease: 'elastic.out(1, 0.5)',
      });
    }
  };

  window.addEventListener('mousemove', onMove);
}
